import React from 'react';
import Stepper from '../features/payment/components/Stepper';

const StepperPage = () => {
  return <Stepper />;
};

export default StepperPage;
